const COLUMNS_GROUPS = [
  {
    id: "date",
    label: "Date",
    widget: "date",
    width: 140
  },
  {
    id: "billNumber",
    label: "Bill#",
    widget: "text",
    width: 160
  },
  {
    id: "referenceNumber",
    label: "Reference Number",
    widget: "text",
    width: 200
  },
  {
    id: "vendorName",
    label: "Vendor Name",
    widget: "text",
    width: 220
  },
  {
    id: "status",
    label: "Status",
    widget: "status",
    width: 130
  },
  {
    id: "dueDate",
    label: "Due Date",
    widget: "date",
    width: 150
  },
  {
    id: "amount",
    label: "Amount",
    widget: "number",
    width: 150
  },
  {
    id: "balanceDue",
    label: "Balance Due",
    widget: "number",
    width: 160
  }
];

const ROW_DATA = [
  {
    date: "2025-01-05",
    billNumber: "BILL-45001",
    referenceNumber: "REF-88021",
    vendorName: "ABC Electronics",
    status: "Unpaid",
    dueDate: "2025-01-20",
    amount: 35400,
    balanceDue: 35400
  },
  {
    date: "2025-01-10",
    billNumber: "BILL-45002",
    referenceNumber: "REF-88045",
    vendorName: "OfficeMart India",
    status: "Partially Paid",
    dueDate: "2025-01-25",
    amount: 18900,
    balanceDue: 7400
  },
  {
    date: "2025-01-15",
    billNumber: "BILL-45003",
    referenceNumber: "REF-88078",
    vendorName: "CleanPro Services",
    status: "Paid",
    dueDate: "2025-01-30",
    amount: 6200,
    balanceDue: 0
  }];

export {COLUMNS_GROUPS,ROW_DATA};